import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { motion, scale } from "framer-motion";
import { FaGlobe, FaBullseye, FaThList, FaUserTie, FaCogs } from "react-icons/fa";


export default function Servicios() {
  const { t } = useTranslation();

  const servicios = [
    {
      icon: <FaGlobe />, 
      title: t("servicios.web.title"),
      desc: t("servicios.web.desc"),
    },
    {
      icon: <FaBullseye />, 
      title: t("servicios.landing.title"),
      desc: t("servicios.landing.desc"),
    },
    {
      icon: <FaThList />, 
      title: t("servicios.catalogo.title"),
      desc: t("servicios.catalogo.desc"),
    },
    {
      icon: <FaUserTie />, 
      title: t("servicios.personal.title"),
      desc: t("servicios.personal.desc"),
    },
    {
      icon: <FaCogs />, 
      title: t("servicios.medida.title"),
      desc: t("servicios.medida.desc"),
    },
  ];

  const whatsappLink = (servicio) =>
    `https://wa.me/522441043578?text=Hola,%20me%20interesa%20una%20cotizaci%C3%B3n%20de%20${encodeURIComponent(servicio)}`;

  return (
    <Section id="servicios">
      <Title>{t("servicios.titulo")}</Title>
      <Grid>
        {servicios.map((s, i) => (
          <Card
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: i * 0.2 }}
          >
            <Icon>{s.icon}</Icon>
            <ServiceTitle>{s.title}</ServiceTitle>
            <Description>{s.desc}</Description>
            <Button href={whatsappLink(s.title)} target="_blank"
            whileHover={{scale: 1.2}}
            whileTap={{scale:.7}}
            >
              {t("servicios.boton")}
            </Button>
          </Card>
        ))}
      </Grid>
    </Section>
  );
}
const Section = styled.section`
  color: #fff;
  padding: 4rem 1rem;
  text-align: center;
`;

const Title = styled.h2`
  color: #ff4c4c;
  font-size: 2rem;
  margin-bottom: 2rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
`;

const Card = styled(motion.div)`
  background-color: #1a1a1a;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 0 10px rgba(255, 76, 76, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border: 2px solid transparent;
  transition:  background .4s, border 1s;
  
  @media(min-width: 1024px) {
    cursor: pointer;
      &:hover {
        background-color:rgb(15, 15, 15);
        border: 2px solid #ff0f0f;
        }
       
    }
`;

const Icon = styled.div`
  font-size: 2rem;
  color: #ff4c4c;
`;

const ServiceTitle = styled.h3`
  font-size: 1.2rem;
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: #ccc;
`;

const Button = styled(motion.a)`
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border: 1px solid #ff4c4c;
  color: #ff4c4c;
  border-radius: 0.375rem;
  transition: background-color 0.6s;
  text-decoration: none;
  @media(min-width: 1024px) {
      &:hover {
      background-color: #ff4c4c;
      color: #fff;
    }
  }
`;